"use client";

import { Box, styled, Typography } from "@mui/material";

const FormTitle = styled(Box)({
  marginBottom: "8px",

  "& span": {
    paddingLeft: "2px",
    color: "red",
  },
});

const FormFieldTitle = ({ children, required }) => (
  <FormTitle>
    <Typography variant="h4">
      {children}
      {required && <span>*</span>}
    </Typography>
  </FormTitle>
);

export default FormFieldTitle;